<div class="modal-header" #addcoverphoto>
  <h1 id="modal-title" class="modal-title">{{ "profile.edit.upload_file" | translate }}</h1>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="workspaceUploadLoader"></myp-inline-loader>
  {{ message }}
  @if (!loading) {
    @if (isShowcase) {
      <div>
        {{ "com.choose_mp3_showcase" | translate }}
      </div>
    }
    @if ((!uploader || (!uploader.queue.length && !uploadingComplete)) && !fileResponse) {
      <div ng2FileDrop class="drop-zone" [class.hovering]="hasBaseDropZoneOver" (fileOver)="fileOverBase($event)" [uploader]="uploader">
        {{ (hasBaseDropZoneOver ? "profile.edit.dropit" : "profile.edit.drophere") | translate }}
        <!-- <span class="text-sm">{{ 'profile.edit.accepted_formats' | translate }}: .jpg, .png</span> -->
        <br />
        <br />
        <div>
          or
          <input type="file" ng2FileSelect [uploader]="uploader" />
        </div>
        <span style="font-size: 12px; color: gray; text-align: center; display: block; max-width: 400px; margin: 30px auto 0px auto">
          {{ "com.upload_copyright_warning" | translate }}
          <br />
          {{ "com.max_upload_filesize" | translate }}
        </span>
      </div>
    }
    @if (!progress && uploader.queue.length && !uploader.isUploading && !fileResponse) {
      <div>
        <div>
          <h5>Queued to upload:</h5>
          @for (item of uploader.queue; track item) {
            <div style="position: relative">
              <span style="color: gray; font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">
                {{ item?.file?.name }}
                @if (!isPostAttachment && !isShowcase) {
                  to
                  <code>{{ folder?.filename || "Home" }}</code>
                }
              </span>
              @if (!isPostAttachment && !isShowcase && !coverPhoto) {
                <div class="form-group m-t-20">
                  <label class="control-label" for="description">{{ "sphere.upload.enter_description_file" | translate }}</label>
                  <textarea name="description" id="description" [(ngModel)]="fileToUpload.description" class="form-control"></textarea>
                </div>
              }
              @if (isShowcase) {
                <div class="form-group m-t-20">
                  <label class="control-label" for="description">{{ "com.enter_description_showcase" | translate }}</label>
                  <textarea name="description" id="description" [(ngModel)]="fileToUpload.description" class="form-control"></textarea>
                </div>
              }
              @if (!isPostAttachment && !isShowcase && audioTypes[item.file.type]) {
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="mainMix" id="mainMix" />
                  <label class="form-check-label" for="mainMix">{{ "sphere.workspaces.most_recent_mixdown" | translate }}</label>
                  <br />
                  <small>{{ "sphere.workspaces.mixdown_if_checked" | translate }}</small>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (uploadingFile && (progress || progress === 0) && !fileResponse) {
      <div>
        <div style="position: relative">
          <span style="color: gray; font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">{{ "general.uploading" | translate }} {{ uploadingFile.filename }}</span>
          <br />
          <br />
          <div style="display: inline-block; margin: auto">
            <round-progress
              [current]="progress"
              [max]="100"
              [color]="'#45ccce'"
              [background]="'#eaeaea'"
              [radius]="125"
              [stroke]="20"
              [semicircle]="false"
              [rounded]="true"
              [clockwise]="true"
              [responsive]="false"
              [duration]="250"
              [animation]="'easeInOutQuart'"
              [animationDelay]="0"
            ></round-progress>
          </div>
          <br />
          @if (!uploadingComplete) {
            <span class="uploading-label">{{ progress }}%</span>
          }
          @if (uploadingComplete && !fileResponse) {
            <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
          }
        </div>
        <br />
        <br />
        <span style="font-size: 12px; color: gray; text-align: center; display: block; max-width: 400px; margin: auto">{{ "com.can_close_upload" | translate }}</span>
      </div>
    }
    @if (fileResponse) {
      <div class="m-y-20 text-center">
        {{ error ? error : ("sphere.upload.success" | translate) }}
      </div>
    }
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary m-r-10" [disabled]="loading" (click)="getUploadUrl()">{{ "sphere.upload.upload_now" | translate }}</button>
  <button type="button" class="btn btn-blank" [disabled]="loading" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
